import { useState } from "react";

export const useHomeStates = () => {
  // 明細取得中フラグ
  //const [gettingAccounts, setGettingAccounts] = useState(false);
  const [openModal, setOpenModal] = useState<
      undefined
    | "Trades"
    | "AddNewAccounts"
    | "AddAccountGroup"
    | "SelectAccounts"
  >(undefined);
  // 口座グループ取得完了フラグ
  const [initGetAccountGroupsCompleted, setInitGetAccountGroupsCompleted] = useState(false);
  // 口座グループ一覧取得しなおしトリガー
  const [refreshAccountGroups, setRefreshAccountGroups] = useState(0);
  // 口座一覧取得しなおしトリガー
  const [refreshAccounts, setRefreshAccounts] = useState(0);

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    openModal,
    setOpenModal,
    initGetAccountGroupsCompleted,
    setInitGetAccountGroupsCompleted,
    refreshAccountGroups,
    setRefreshAccountGroups,
    refreshAccounts,
    setRefreshAccounts,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
